import React from 'react';

import {ALLOWED_TIMEZONE} from 'graphql-client/__generated/GeneratedEnumMaps';
import {AllowedTimezone} from 'graphql-client/__generated/graphqlGlobalTypes';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

interface ControlledTimezonePickerInputProps {
  timezone: AllowedTimezone;
  onSelect: (timezone: AllowedTimezone) => void;
}

export default function ControlledTimezonePickerInput(
  props: ControlledTimezonePickerInputProps
): JSX.Element {
  return (
    <div className="u-small-spacing-bottom">
      <SelectDropdown
        displayName={
          ALLOWED_TIMEZONE.hasOwnProperty(props.timezone)
            ? ALLOWED_TIMEZONE[props.timezone]
            : 'Select timezone'
        }
        allowMenuToCloseDropdown={false}
        menu={
          <SearchableMenu
            selectedValue={props.timezone}
            onSelect={props.onSelect}
            optionDatas={Object.keys(ALLOWED_TIMEZONE).map((tz) => ({
              name: ALLOWED_TIMEZONE[tz as AllowedTimezone],
              value: tz,
            }))}
            height={Menu.HEIGHTS.MEDIUM}
            width={Menu.WIDTHS.FULL}
          />
        }
        dataTestAttrs={{component: 'ControlledLanguagePickerInput', element: 'root'}}
      />
    </div>
  );
}
